import React, { useEffect, useState } from 'react';
import { Row, Card, Button } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import OportunityListRead from '../../service/GasOrderListRead';

import {
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../../../assets/styles/table_custom_style';

const Analytical = ({
  dataOportunnityList,
  areaList,
  phaseList,
  reasonList,
  subReasonList
}) => {
  const history = useHistory();
  const [newData, setNewData] = useState([]);

  let newDataHolder = [];

  const fillTableInfo = () => {
    if (JSON.stringify(dataOportunnityList).length > 2) {
      dataOportunnityList.map((info, index) => {
        const areaName = areaList.find(
          (element) => element.responsableArea === info.areaId
        );

        const faseName = phaseList.find(
          (element) => element.oportunnityPhase === info.faseId
        );

        const motivoName = reasonList.find(
          (element) => element.motive === info.motivoId
        );

        const subMotiveName = subReasonList.find(
          (element) => element.subMotive === info.submotivoId
        );

        let p5Quantity = 0;
        let p8Quantity = 0;
        let p13Quantity = 0;
        let p20Quantity = 0;
        let p45Quantity = 0;
        let granelQuantity = 0;

        info.produtos.map((produtos) => {
          switch (produtos.produtoId) {
            case 'f4a108f7-39c7-4c87-adc8-33942bc24d1f':
              p5Quantity = produtos.quantidade;

              break;
            case '413d53c0-0eb0-4d6b-87ef-dd5eda13ea9b':
              p8Quantity = produtos.quantidade;

              break;
            case '6abfe98f-43c1-4a69-8469-a44551957ac4':
              p13Quantity = produtos.quantidade;

              break;
            case '26232397-db1b-4301-8388-84f5309c16ec':
              p20Quantity = produtos.quantidade;

              break;
            case 'f387183d-3925-4a01-a8aa-759cbbe38f09':
              p45Quantity = produtos.quantidade;

              break;
            case '0bd36383-5292-4b55-ab7c-8305ee38916a':
              granelQuantity = produtos.quantidade;

              break;
            default:
              break;
          }
        });
        info = {
          ...info,
          p5Quantity: p5Quantity,
          p8Quantity: p8Quantity,
          p13Quantity: p13Quantity,
          p20Quantity: p20Quantity,
          p45Quantity: p45Quantity,
          granelQuantity: granelQuantity,
          subMotiveName: subMotiveName ? subMotiveName.label : '',
          motivoName: motivoName ? motivoName.label : '',
          areaName: areaName ? areaName.label : '',
          faseName: faseName ? faseName.label : ''
        };
        return (newDataHolder[index] = info);
      });
    }
  };

  useEffect(() => {
    setNewData(newDataHolder);
    fillTableInfo();
  }, [dataOportunnityList, areaList, subReasonList, reasonList, phaseList]);

  const individualStyle = newData.map((info) => {
    if (info.area.descricao === 'SITE') {
      return {
        ...individual_column_style,
        id: info.id,
        backgroundColor: `${info.lido === null ? '#86b089' : 'none'}`,
        color: `${info.lido === null ? '#fff' : '#000'}`
      };
    } else {
      return {
        ...individual_column_style,
        id: info.id,
        backgroundColor: `${info.lido === false ? '#cf657a' : 'none'}`,
        color: `${info.lido === false ? '#fff' : '#000'}`
      };
    }
  });

  function atualizar(newData) {
    const newDataHolder = {
      idOportunidades: [newData.id]
    };
    OportunityListRead.putReader(newDataHolder).catch((err) => {
      toast.error(err, {
        autoClose: 3000,
        closeOnClick: true
      });
    });
  }

  function formatDateToShow(date) {
    const dateObj = new Date(date);
    return `${dateObj.toLocaleDateString(
      'pt-br'
    )} às ${dateObj.toLocaleTimeString('pt-br', {
      hour12: false
    })}`;
  }

  return (
    <>
      <Row className="mt-3">
        <div className="col">
          <div className="card-wrapper">
            <Card>
              <ToolkitProvider
                data={newData || []}
                keyField="uuid"
                columns={[
                  {
                    dataField: 'edit',
                    text: 'Editar pedido',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style,
                    // eslint-disable-next-line react/display-name
                    formatter: (_, row, rowIndex) => {
                      return (
                        <Button
                          size="sm"
                          color="info"
                          onMouseDown={(event) => {
                            event.stopPropagation();
                            let copyNewData = newData;
                            setNewData(
                              [...copyNewData],
                              (newData[rowIndex].lido = true)
                            );
                            atualizar(copyNewData[rowIndex]);
                            if (event.button == 1 || event.button == 2) {
                              window.open(
                                `/oportunity/editOportunity/${row.id}?isNewTab=true`,
                                '_blank'
                              );
                            }
                          }}
                          onClick={() => {
                            let copyNewData = newData;
                            setNewData(
                              [...copyNewData],
                              (newData[rowIndex].lido = true)
                            );
                            atualizar(copyNewData[rowIndex]);
                            history.push(
                              `/admin/gas-order/form/${row.id}?isNewTab=false`
                            );
                          }}
                        >
                          <li className="fas fa-edit"></li>
                        </Button>
                      );
                    }
                  },
                  {
                    dataField: 'numero',
                    text: 'Número da Oportunidade',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'protocoloExterno',
                    text: 'Protocolo Externo',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'conta.nome',
                    text: 'Cliente',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'email',
                    text: 'Email',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  // {
                  //   dataField: 'emailDaRegional',
                  //   text: 'Destinatário',
                  //   sort: true,
                  //   style: (_, col) => {
                  //     return individualStyle.find(
                  //       (element) => element.id === col.id
                  //     );
                  //   },
                  //   headerStyle: individual_header_style
                  // },
                  {
                    dataField: 'nomeRegional',
                    text: 'Regional',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style,
                    formatter: (_, row) => {
                      if (row?.conta?.nomeRegional) {
                        return row?.conta?.nomeRegional;
                      }

                      const email = row?.emailDaRegional ?? '';

                      if (email.includes('programacaonordeste1')) {
                        return 'NORDESTE I';
                      } else if (email.includes('programacaonorte')) {
                        return 'NORTE';
                      } else if (email.includes('programacaonordeste2')) {
                        return 'NORDESTE II';
                      } else if (email.includes('programacaosudeste')) {
                        return 'SUDESTE/CO';
                      } else if (email.includes('programacaosul')) {
                        return 'SUL';
                      }

                      return '';
                    }
                  },
                  {
                    dataField: 'conta.cpfCnpj',
                    text: 'CNPJ/CPF',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'proprietario.name',
                    text: 'Responsável',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'criadoEm',
                    text: 'Data de Atendimento',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style,
                    formatter: (row) => {
                      return formatDateToShow(row);
                    }
                  },
                  {
                    dataField: 'dataAgendamento',
                    text: 'Data de Agendamento',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style,
                    formatter: (row) => {
                      return formatDateToShow(row);
                    }
                  },
                  {
                    dataField: 'motivoName',
                    text: 'Motivo de Atendimento',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'subMotiveName',
                    text: 'Submotivo de Atendimento',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'areaName',
                    text: 'Área Responsável',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'conta.filial',
                    text: 'Filial',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'p5Quantity',
                    text: 'P5',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'p8Quantity',
                    text: 'P8',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'p13Quantity',
                    text: 'P13',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'p20Quantity',
                    text: 'P20',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'p45Quantity',
                    text: 'P45',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'granelQuantity',
                    text: 'Granel(Kg)',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'prioridade',
                    text: 'Modalidade',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'formaDePagamento',
                    text: 'Forma de Pagamento',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'diasDePagamento',
                    text: 'Dias de Pagamento',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'faseName',
                    text: 'Status Atual',
                    sort: true,
                    style: (_, col) => {
                      return individualStyle.find(
                        (element) => element.id === col.id
                      );
                    },
                    headerStyle: individual_icon_header_style
                  }
                ]}
              >
                {(props) => (
                  <div className="table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      keyField="id"
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};
export default Analytical;
